import { Injectable } from '@angular/core';

import * as fileSaver from 'file-saver';
import { ConfigServerService, CustomHttp } from '../../../../../core';
import { ClienteFilter } from '../../filter';
import { HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ClienteContatoExcelHttpService {
    private readonly resource = 'clientecontato';
    private readonly path: string;


    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.path = `${configServerService.getPathApiExcel()}/${this.resource}`;
    }

    /** Realiza a exportação da pesquisa dos contato dos clientes */
    export(filter: ClienteFilter, nomeExportacao = ''): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            // Params
            let params = new HttpParams()
                                .append('nomeExportacao', nomeExportacao);

            // Filter
            if (filter) {
                params = filter.createParams(params);
            }

             this.customHttp.get<Blob>(`${this.path}/export`, {params, responseType: 'blob'})
                .subscribe(
                    excel => {
                        nomeExportacao = nomeExportacao.replace('.xlsx', '');
                        fileSaver.saveAs(excel, `${nomeExportacao}.xlsx`);
                        resolve();
                    },
                    error => {
                        reject(error);
                    }
                );
        });
    }
}
